/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc
 */

/**
 *  Application domain information containing domain and verification status.
 *  Used to encapsulate domain data for applications.
 */

/**
 *  Application listing information from the marketplace/ecosystem service.
 *  Contains metadata about an app's marketplace listing status.
 */

/**
 *  Application project information containing project ID and name.
 *  Used to encapsulate project association data for applications.
 */

/**
 *  This immutable combines ApplicationCore with additional fields stored
 *  in the Applications tablespace, such as scope groups.
 */

/**
 *  Request for getting applications by portalId with optional filtering.
 */

/**
 *  Response containing applications filtered by origin.
 */

export const getAppComponentIndexByAppIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getAppComponentIndexByAppId',
  auth: 'app',
  fingerprint: 'zfOlZmbh4S7CUw_0xoo1lp6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApplicationsForPortalRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getApplicationsForPortal',
  auth: 'app',
  fingerprint: 'QkdylmeQNfE-G7BKctz1Dp6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getApplicationsByProjectAndPortalRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getApplicationsByProjectAndPortal',
  auth: 'app',
  fingerprint: '06TKAzFgrCILbqe8XZhjA5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByClientIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getByClientId',
  auth: 'app',
  fingerprint: 'r8J76bURmeRyKrTb1tfPfJ6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'kKovnN-6qzpyKrTb1tfPfJ6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getByIdsRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getByIds',
  auth: 'app',
  fingerprint: '3qtvWDEg8ZbhtK_iucj1MZ6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAiConnectorCatalogRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getAiConnectorCatalog',
  auth: 'app',
  fingerprint: '_yHDXGksR777phBdz2eH5Z6EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLocalisedAppPermissionsRpc = {
  serviceName: 'com.hubspot.applications.rpc.ApplicationsRpc',
  rpcName: 'getLocalisedAppPermissions',
  auth: 'app',
  fingerprint: 'vqizbSwz5lBlPrKLuON8w56EA-yclie3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};